// Vue
import {Vue, Component, Prop, Watch} from 'vue-property-decorator'

// Template
import template from './template.vue'
import {JobStatus} from "../../../../interfaces/JobStatus";

@Component({
    mixins: [
        template,
    ]
})
export class JobStatusLogView extends Vue {

    @Prop()
    public status!: JobStatus

    @Prop({default: 400})
    public maxHeight!: number

    private userScroll = false

    private highlighedLine = -1;

    public onLineClick(index) {
        if (this.highlighedLine == index) {
            this.highlighedLine = -1;
        } else {
            this.highlighedLine = index;
        }
    }

    @Watch('status', {deep:true})
    private onStatusChange() {
        this.updateScroll();
    }

    public onScrollList(event) {
        let element = this.$refs['list'] as HTMLElement;
        if (element.scrollTop == element.scrollHeight - element.clientHeight) {
            this.userScroll = false;
        } else {
            this.userScroll = true;
        }
    }

    private updateScroll() {
        if (!this.userScroll) {
            this.$nextTick(() => {
                let element = this.$refs['list'] as HTMLElement;
                element.scrollTop = element.scrollHeight - element.clientHeight;
            });
        }
    }
}